import React, { memo, useRef } from 'react';
import { formats } from 'investira.sdk';
import { Stack, Typography, Chip, useMediaQuery, Icon } from 'investira.react.components';
import { displays } from 'investira.react.lib';
import { ATIVO_MERCADO } from '@investirapri/financa.js/lib/enums';
import { PessoaImage } from '../../molecules';

/**
 * Renderiza o componente SearchIndicadoresItem.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {*} props.pessoa - Propriedade `pessoa` do componente.
 * @param {*} props.onClick - Propriedade `onClick` do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const SearchIndicadoresItem = memo(props => {
  const { pessoa, onClick } = props;

  return (
    <Stack
      id={pessoa.pessoa_id}
      key={pessoa.pessoa_id}
      direction="row"
      spacing={3}
      alignItems="center"
      component="li"
      onClick={onClick}
      sx={{
        px: 2,
        py: 1,
        cursor: 'pointer',
        '&:hover': {
          color: 'gray',
          backgroundColor: 'background.main'
        }
      }}>
      <Stack>
        <PessoaImage
          logoPessoaId={pessoa.logo_pessoa_id}
          alt={pessoa.pessoa}
          hasLogo={pessoa.logo_ok}
          size={36}
        />
      </Stack>
      <Stack>
        <Typography variant="body2" color="textPrimary">
          {pessoa.pessoa_fantasia || pessoa.pessoa}
        </Typography>
        <Stack direction="row" spacing={{ xs: 0, sm: 1 }}>
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{
              display: { xs: 'none', sm: 'inline-block' }
            }}>
            {`${pessoa.pessoa}`}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {`${displays.cnpj(pessoa.cnpj)}`}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
});

export default SearchIndicadoresItem;
